<script lang="ts">
    let className: string = "";
    export { className as class };
    export let style: string = "";
</script>

<svg
    {style}
    class={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
>
    <title>Project</title>
    <g
        id="Stockholm-icons-/-Code-/-Git#4"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
    >
        <rect id="Rectangle-5" x="0" y="0" width="24" height="24" />
        <path
            d="M6 7c1.1045695.0 2-.8954305 2-2S7.1045695 3 6 3 4 3.8954305 4 5s.8954305 2 2 2zM6 9C3.790861 9 2 7.209139 2 5 2 2.790861 3.790861 1 6 1s4 1.790861 4 4S8.209139 9 6 9z"
            id="Oval-7"
        />
        <path
            d="M7 11.4648712V17c0 1.1045695.8954305 2 2 2h6v2H9c-2.209139.0-4-1.790861-4-4V8 7H7V8c0 1.1045695.8954305 2 2 2h6v2H9C8.27142571 12 7.58834673 11.8052114 7 11.4648712z"
            id="Combined-Shape"
            opacity=".3"
        />
        <path
            d="M18 22c1.1045695.0 2-.8954305 2-2s-.8954305-2-2-2-2 .8954305-2 2 .8954305 2 2 2zm0 2c-2.209139.0-4-1.790861-4-4s1.790861-4 4-4 4 1.790861 4 4-1.790861 4-4 4z"
            id="Oval-7-Copy"
        />
        <path
            d="M18 13c1.1045695.0 2-.8954305 2-2s-.8954305-2-2-2-2 .8954305-2 2 .8954305 2 2 2zm0 2c-2.209139.0-4-1.790861-4-4s1.790861-4 4-4 4 1.790861 4 4-1.790861 4-4 4z"
            id="Oval-7-Copy-3"
        />
    </g>
</svg>
